import { render, staticRenderFns } from "./step_02.vue?vue&type=template&id=97a23be0&scoped=true"
import script from "./step_02.vue?vue&type=script&lang=js"
export * from "./step_02.vue?vue&type=script&lang=js"
import style0 from "./step_02.vue?vue&type=style&index=0&id=97a23be0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a23be0",
  null
  
)

export default component.exports